<template>
  <div>
    <detail  :billId="id"/>

  </div>
</template>

<script>
import detail from '@/components/settlement/ChannelDetailSettlement'

export default {
  props: {
    id: {
      type: [String, Number],
      required: true
    }
  },
  components: {
    detail
  }
}
</script>
